import { gte } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import Ember from 'ember';
import DS from 'ember-data';
import { task } from 'ember-concurrency';
import { timeout } from 'ember-concurrency';

import RavenService from 'cio/services/raven';

const FETCH_THROTTLE = 5 * 1000;

export default class CustomerCounterService extends Service {
  @service store!: DS.Store;
  @service raven!: RavenService;

  reloadCustomers = task(async () => {
    //eslint-disable-next-line no-constant-condition
    while (true) {
      try {
        let customers: any = await this.store.query('customer', { page: 1 });
        this.set('count', customers.get('meta.pagination.total'));
      } catch (e) {
        this.raven.captureException(e);
      }

      if (Ember.testing) {
        break;
      }

      await timeout(FETCH_THROTTLE);
    }
  });

  // external API
  count!: number;
  @gte('count', 20) hasEnough!: boolean;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'customer-counter': CustomerCounterService;
  }
}
